module.exports = __webpack_public_path__ + "media/images/help/flow/pill-1month-3e7836cff59a34d72a35fc63e6f64d1f.svg";